module.exports = __webpack_public_path__ + "static/TeamAugmentation-c7fc15bda093fe0959b4add017309d9f.png";